import styled from '@emotion/styled'
import { Box } from '@gousto-internal/citrus-react'

import { customBreakpoint, largeGapGridTemplateColumns } from './constants'

export const TableRowContainer = styled(Box)(() => ({
  [customBreakpoint]: {
    gridTemplateColumns: largeGapGridTemplateColumns,
  },
}))
